import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Module, MutationTree, GetterTree, ActionTree } from 'vuex';
import { RootState } from '@core/interfaces/root-state';

import { getProp, setProp } from '@shared/helpers/operators';
import { MessageState } from '@communications/interfaces/message-state';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { bpcApi } from '@core/services/bpc-api.service';

const bpcRouterHelper = new BPCApiRouteHelper();

// Initial state
const state: MessageState = {
  messages: [],
  loading: false,
};

// Synchronous functions to get data from state (can be composed properties)
const getters: GetterTree<MessageState, RootState> = {
  isLoading(state): boolean {
    return !!state.loading;
  },
  allMessages(state): object {
    return state.messages;
  },
  unreadMessages(state): object {
    return state.messages.filter(message => message['status'] === 'unread');
  },
  message: state => (id: string) => {
    return getProp(state.messages, id);
  },
};

// Asynchornous functions to get data usually from an api call
const actions: ActionTree<MessageState, RootState> = {
  // Get Messages
  getMessages({ commit, getters, rootGetters }) {
    commit('startLoading');
    const contactId = rootGetters['auth/contactId']({
      tenantId: rootGetters['tenant/selectedTenantId'],
    });
    const messagesPath = `${bpcRouterHelper.getEntityPath(
      'message',
    )}?received_by_contact_id=${contactId}&status=unread`;

    bpcApi.get(messagesPath, {}, 'admin').subscribe(
      (res: BPCGenericApiResponse) => {
        commit('storeMessages', res.data);
      },
      error => {
        commit('stopLoading');
      },
      () => {
        commit('stopLoading');
      },
    );
  },
};

// The vuex way of changing a state property
const mutations: MutationTree<MessageState> = {
  stopLoading(state) {
    state.loading = false;
  },
  startLoading(state) {
    state.loading = true;
  },
  storeMessages(state, data) {
    setProp(state, 'messages', data);
  },
};

export const MessageStoreModule: Module<MessageState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
